import { render, staticRenderFns } from "./CustomisationPage.vue?vue&type=template&id=0d03673d&"
import script from "./CustomisationPage.vue?vue&type=script&lang=js&"
export * from "./CustomisationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports